// A mock function to mimic making an async request for data
import axios from "axios";
export function createSubcategory(subcategory) {
  return new Promise(async (resolve) => {
    const response = await axios.post(
      process.env.REACT_APP_BASE_API+"/subcategory/add-subcategory",
      subcategory
    );
    const data = response.data;

    resolve({ data });
  });
}

export function fetchSubcategoryByAdmin() {
  return new Promise(async (resolve) => {
    const response = await axios.get(
      process.env.REACT_APP_BASE_API+"/subcategory/get-subcategory-admin"
    );
    const data = response.data;
    resolve({ data });
  });
}

export function fetchSubCategoryById(subcategoryId) {
  return new Promise(async (resolve) => {
    const response = await axios.post(
      process.env.REACT_APP_BASE_API+"/subcategory/get-subcategory-by-id",
      {
        subcategoryId: subcategoryId,
      }
    );

    const data = response.data;
    resolve({ data });
  });
}

export function updateSubategory(subcategoryId, newSubcategory) {
  return new Promise(async (resolve) => {
   const response = await axios.put(
    process.env.REACT_APP_BASE_API+"/subcategory/update-subcategory",
     {
       subcategoryId: subcategoryId,
       categoryId: newSubcategory.categoryId,
       subcategoryName: newSubcategory.subcategoryName,
       subcategoryImage: newSubcategory.subcategoryImage,
     }
   );
    const data = response.data;

    resolve({ data });
  });
}

export function deleteSubcategeoryById(subcategoryId) {
  return new Promise(async (resolve) => {
   const response = await axios.patch(
     `${process.env.REACT_APP_BASE_API}/subcategory/delete-subcategory/${subcategoryId}`
   );
    const data = response.data;
    resolve({ data });
  });
}
export function toggleSubcategoryStatus(subcategoryId) {
  return new Promise(async (resolve) => {
   const response = await axios.patch(
     `${process.env.REACT_APP_BASE_API}/subcategory/toggle-subcategory-status/${subcategoryId}`
   );
    const data = response.data;
    resolve({ data });
  });
}

export function fetchSubCategoryNameByCategoryId(categoryId) {
  return new Promise(async (resolve) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_API}/subcategory/get-subcategory-name/${categoryId}`
    );

    const data = response.data;
    resolve({ data });
  });
}
export function fetchSubCategoryByCategoryId(categoryId) {
  return new Promise(async (resolve) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_API}/subcategory/get-subcategory-by-category-id/${categoryId}`
    );

    const data = response.data;
    resolve({ data });
  });
}
